var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-7 md:grid-cols-14 gap-y-1 gap-x-3 items-center justify-between px-3 py-3"},[(
			!(
				_vm.referenceTradable.user.type == 'FARMER' &&
				_vm.referenceTradable.trade == 'SELL'
			)
		)?_c('div',{staticClass:"col-span-1 text-gray-900 whitespace-nowrap font-semibold"},[_vm._v("\n\t\t"+_vm._s(_vm.match.offer.qty.mt)+" t\n\t")]):_vm._e(),_vm._v(" "),(
			!(
				_vm.referenceTradable.user.type == 'FARMER' &&
				_vm.referenceTradable.trade == 'SELL'
			)
		)?_c('div',{staticClass:"col-span-2 text-gray-500 truncate text-sm xl:text-base"},[_vm._v("\n\t\t"+_vm._s(_vm.$cropOptions.getLocalizedLabel(
				_vm.match.offer.product.grade,
				_vm.$cropOptions.productGradeOptions
			))+"\n\t")]):_vm._e(),_vm._v(" "),(
			_vm.referenceTradable.user.type == 'FARMER' &&
			_vm.referenceTradable.trade == 'SELL'
		)?_c('div',{staticClass:"col-span-3 text-gray-500 text-sm xl:text-base"},[_vm._v("\n\t\t"+_vm._s(_vm.$cropOptions.getLocalizedLabel(
				_vm.match.offer.product.grade,
				_vm.$cropOptions.productGradeOptions
			))+"\n\t\t"+_vm._s(_vm.__("Harvest"))+" "+_vm._s(_vm.match.offer.product.harvest || _vm.__("n.a."))+"\n\t")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-span-4 md:col-span-3 text-gray-500 text-sm xl:text-base leading-4 flex gap-x-2 flex-wrap xl:gap-x-3 items-center"},[(
				_vm.referenceTradable.user.type == 'FARMER' &&
				_vm.referenceTradable.trade == 'SELL' &&
				_vm.match.offer.location.mode == 'DAP' &&
				_vm.match.offer.location.optional_transport
			)?_c('div',{staticClass:"whitespace-nowrap"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$cropOptions.getLocalizedLabel(
					"FCA",
					_vm.$cropOptions.locationModeOptions
				))+"\n\t\t")]):_c('div',{staticClass:"whitespace-nowrap"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$cropOptions.getLocalizedLabel(
					_vm.match.offer.location.mode,
					_vm.$cropOptions.locationModeOptions
				))+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"whitespace-nowrap"},[(
					(_vm.referenceTradable.user.type == 'FARMER' &&
						_vm.referenceTradable.trade == 'SELL' &&
						_vm.match.offer.location.mode == 'DAP' &&
						_vm.match.offer.location.optional_transport) ||
					(_vm.referenceTradable.user.type == 'FARMER' &&
						_vm.referenceTradable.trade == 'SELL' &&
						_vm.match.offer.location.mode == 'FCA')
				)?_c('span',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.referenceTradable.location.address.city)+"\n\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.match.offer.location.address.city)+"\n\t\t\t")]),_vm._v(" "),(
					_vm.match.distance_km_road &&
					!(
						_vm.referenceTradable.user.type == 'FARMER' &&
						_vm.referenceTradable.trade == 'SELL' &&
						_vm.match.offer.location.mode == 'DAP' &&
						_vm.match.offer.location.optional_transport
					) &&
					!(
						_vm.referenceTradable.user.type == 'FARMER' &&
						_vm.referenceTradable.trade == 'SELL' &&
						_vm.match.offer.location.mode == 'FCA'
					)
				)?_c('span',[_vm._v("\n\t\t\t\t("+_vm._s(_vm.match.distance_km_road.toFixed(0))+" km)\n\t\t\t")]):_vm._e()])]),_vm._v(" "),(
			_vm.referenceTradable.user.type == 'FARMER' &&
			_vm.referenceTradable.trade == 'SELL'
		)?_c('div',{staticClass:"col-span-7 md:col-span-4 text-gray-500 text-sm xl:text-base"},[_vm._v("\n\t\t"+_vm._s(_vm.$cropOptions.dateToString(this.match.offer, this.locale))+"\n\t")]):_vm._e(),_vm._v(" "),(
			!(
				_vm.referenceTradable.user.type == 'FARMER' &&
				_vm.referenceTradable.trade == 'SELL'
			)
		)?_c('div',{staticClass:"hidden md:flex flex-nowrap text-gray-500"},[_c('ui-icon',{staticClass:"w-5 h-5",attrs:{"name":"arrow-left","stroke":"2"}}),_vm._v(" "),_c('ui-icon',{staticClass:"w-5 h-5",attrs:{"name":"arrow-right","stroke":"2"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.priceContainerCss},[(_vm.match.price_estimate)?_c('div',{staticClass:"text-gray-900 font-semibold xl:flex xl:gap-x-3 items-center"},[_c('div',[(
						!(
							_vm.referenceTradable.user.type == 'FARMER' &&
							_vm.referenceTradable.trade == 'SELL' &&
							_vm.match.offer.location.mode == 'DAP' &&
							_vm.match.offer.location.optional_transport
						)
					)?_c('span',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.__("approx."))+"\n\t\t\t\t")]):_vm._e(),_vm._v("\n\t\t\t\t"+_vm._s(_vm.$cropOptions.formatLocalizedNumber(_vm.match.price_estimate))+" €/t\n\t\t\t")]),_vm._v(" "),(
					!(
						_vm.referenceTradable.user.type == 'FARMER' &&
						_vm.referenceTradable.trade == 'SELL'
					)
				)?_c('ui-tooltip',{staticClass:"text-sm xl:text-base font-normal",attrs:{"text":_vm.__('This price is estimated based on freight cost indications')},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"cursor-help text-orange-500"},[_vm._v(_vm._s(_vm.__("Freight cost"))+" ca.\n\t\t\t\t\t\t"+_vm._s(_vm.$cropOptions.formatLocalizedNumber(_vm.match.freight_cost_eur))+"\n\t\t\t\t\t\t€/t")])]},proxy:true}],null,false,3056053868)}):_vm._e()],1):(_vm.match.offer.price.mt)?_c('div',{staticClass:"text-gray-900 font-semibold flex items-center"},[_c('div',{staticClass:"mr-3"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.match.offer.price.mt == null
						? ""
						: _vm.$cropOptions.formatLocalizedNumber(_vm.match.offer.price.mt) +
						  " €/t " +
						  _vm.matchPriceWarning)+"\n\t\t\t")]),_vm._v(" "),(
					!(
						_vm.referenceTradable.user.type == 'FARMER' &&
						_vm.referenceTradable.trade == 'SELL' &&
						_vm.match.offer.location.mode == 'FCA'
					)
				)?_c('div',{staticClass:"text-gray-500 font-normal text-sm xl:text-base"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.__("without freight charges"))+"\n\t\t\t")]):_vm._e()]):_c('div',{staticClass:"text-gray-500 xl:flex items-center text-sm"},[_vm._v("\n\t\t\t"+_vm._s(_vm.__("No price provided"))+"  "),_c('br'),_vm._v(" "),(_vm.match.freight_cost_eur)?_c('span',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.__("messages.freight_charges", {
						args: {
							cost: _vm.$cropOptions.formatLocalizedNumber(
								_vm.match.freight_cost_eur
							),
						},
					}))+"\n\t\t\t")]):_vm._e()]),_vm._v(" "),_c('ui-button',{staticClass:"ml-auto text-sm flex-shrink-0",attrs:{"type":"primary"},on:{"click":function($event){_vm.$bus.$emit(
					'toggle-iframe-modal',
					_vm.$route('bid.create', {
						targetType: _vm.match.offer.trade,
						targetId: _vm.match.offer.id,
						sourceId: _vm.referenceTradable.id,
					}) + '?iframe_modal=true'
				)}}},[_vm._v(_vm._s(_vm.match.offer.trade == "BUY"
					? _vm.referenceTradable.user.type == "FARMER"
						? _vm.__("Offer Quantity")
						: _vm.__("Offer")
					: _vm.__("Bid")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }